
import { isEmpty } from 'lodash';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import QuotationRules from '../../libs/business-logic/Quotation.rules';
import EstimatedDate from '../../components/EstimatedDate.vue';

export default {
  name: 'ActivitiesList',
  components: {
    EstimatedDate,
  },
  props: {
    activitiesList: {
      type: Array,
      required: true,
    },
    activitiesGroup: {
      type: Array,
      default: () => {},
    },
    listType: {
      type: Number,
      required: true,
    },
    activitySelected: {
      type: Number,
      default: null,
    },
    activeTooltip: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tutorialActive: {
      type: Boolean,
      default: false,
    },
    contracted: {
      type: Boolean,
      default: false,
    },
    stepTutorialMobile: {
      type: Number,
      default: 0,
    },
    showTutorialMobile: {
      type: Boolean,
      default: false,
    },
    twoColums: {
      type: Boolean,
      default: false,
    },
    onService: {
      type: Boolean,
      default: false,
    },
    isRepairs: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showTooltip: false,
    toggleWidth: 60,
    expanded: false,
    showTooltipRest: false,
    showList: 0,
  }),
  computed: {
    ...mapGetters('Quotation', {
      quotationItems: 'getQuotationItems',
      orderActual: 'getOrderActual',
    }),
    ...mapGetters('Activity', {
      activitiesGroupedById: 'getActivitiesGroupedById',
    }),

    ...mapGetters('Order', {
      taxPercentage: 'getTaxPercentage',
    }),
    isThemeDefault() {
      return this.$session.get('brand') === '';
    },
    isThemeVolkswagen() {
      return this.$session.get('brand') === 'volkswagen';
    },
    isThemeSeat() {
      return this.$session.get('brand') === 'seat';
    },
    isThemeAudi() {
      return this.$session.get('brand') === 'audi';
    },
    isInternal() {
      return this.$session.get('isInternal');
    },
    icon() {
      const icon = {
        name: '',
        class: '',
        type: '',
      };

      switch (this.listType) {
        case 1:
          icon.name = 'urgent';
          icon.type = !this.isThemeDefault && 's';
          break;
        case 2:
          icon.name = 'preventive';
          icon.type = 's';
          break;
        case 3:
          icon.name = 'repair';
          icon.type = 's';
          break;
        default:
          break;
      }

      return icon;
    },
    desktop() {
      return this.$q.screen.gt.md;
    },
    tablet() {
      return this.$q.screen.lt.lg && this.$q.screen.gt.sm;
    },
    mobile() {
      return this.$q.screen.lt.md;
    },
  },
  watch: {
    activeTooltip(val) {
      if (val) {
        this.showTooltip = true;
      } else {
        this.showTooltip = false;
      }
    },
  },
  mounted() {
    this.authorizeAllGuaranteeActivities();
    this.showList = Vue.prototype.$session.get('showPrice');
  },
  methods: {
    isEmpty,
    validateOrderStatus(status) {
      const BUDGET_STATUS = [103, 104, 105, 107];

      return BUDGET_STATUS.includes(+status) && !this.$session.get('showActivitiesList');
    },
    visualizeReport(activity) {
      this.$emit('visualize-report', { ...activity });
      this.showTooltip = false;
    },
    onResize(size) {
      if (size.width > 60) {
        this.toggleWidth = 60;
      } else {
        this.toggleWidth = size.width;
      }
    },
    formatDate(activity) {
      return this.moment(activity.estimated_date).utc().format('DD-MM-YYYY');
    },

    authorizeAllGuaranteeActivities() {
      this.activitiesList.forEach((activity) => {
        const clonnedActivity = activity;
        if (clonnedActivity.activity_service_type === 2) {
          clonnedActivity.accepted = true;
        }
      });
    },

    getActivitySubtotalAmount(activityId) {
      const subtotal = QuotationRules.getSubtotalAmountOfActivity(
        activityId,
        this.quotationItems,
      );

      return (+subtotal + (+subtotal * this.taxPercentage)).toFixed(2);
    },
  },
};
